import { Injectable, Inject } from '@angular/core';
import { Http } from '@angular/http';
import { AppConfigurationModel } from '../models/appConfiguration.model';

import * as _ from 'lodash';
import { getAppConfigurationUrl } from '../app.urls';
import { SYSTEM_NAME, PRODUCTION_BUILD } from '../app.settings';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppConfigurationProvider {

    private configuration: AppConfigurationModel;

    constructor(@Inject('Location') private location: Location,
        private http: Http) {

    }

    public getConfiguration(): AppConfigurationModel {
        return _.cloneDeep(this.configuration);
    }

    load() {
        return new Promise((resolve, reject) => {
            this.http.get(getAppConfigurationUrl())
                .map(res => res.json())
                .catch((error) => {
                    console.error(error);
                    resolve(true);
                    return Observable.throw('Error');
                })
                .subscribe(
                    (response) => {
                        this.configuration = response;
                        this.checkConfiguration();
                        resolve(true);
                    }
                );
        });
    }

    private checkConfiguration(): void {
        const storedVersion = localStorage.getItem(SYSTEM_NAME.toLowerCase() + '_version');

        if (!this.configuration) {
            console.error('Invalid application configuration!');
            return;
        }

        if (storedVersion) {
            if (this.configuration.version !== storedVersion) {
                if (!PRODUCTION_BUILD) {
                    console.log('Application version mismatch! (' + this.configuration.version + '/' + storedVersion + ') - Reloading...');
                }

                this.updateVersionAndReload();
            } else if (!PRODUCTION_BUILD) {
                console.log('Application version matches latest. (' + storedVersion + ') - No reload required.');
            }
        } else {
            if (!PRODUCTION_BUILD) {
                console.log('Version information not found. Reloading...');
            }

            this.updateVersionAndReload();
        }
    }

    private updateVersionAndReload(): void {
        this.clearSystemLocalStorage();
        localStorage.setItem(SYSTEM_NAME.toLowerCase() + '_version', this.configuration.version);
        
        if (!this.location) {
            location.reload(true);
        } else {
            this.location.reload(true);
        }
    }

    private clearSystemLocalStorage(): void {
        const systemKeys = [];
        const systemName = SYSTEM_NAME.toLowerCase();

        for (let index = 0; index < localStorage.length; index++) {
            const key = localStorage.key(index);
            
            if (_.startsWith(key, systemName)) {
                systemKeys.push(key);
            }
        }

        _.forEach(systemKeys, (key) => {
            localStorage.removeItem(key);
        });
    }
}

export function appConfigurationProviderFactory(provider: AppConfigurationProvider) {
    return () => {
        provider.load();
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/providers/app-configuration.provider.ts